import React, { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Divider, Link, Typography } from '@mui/material';
import { formatCurrency } from 'utils/format';
import { useNavigate } from 'react-router-dom';
import { Invoice } from 'models/invoice';

type CreditInvoicesPanelProps = {
    creditInvoices: Invoice[];
};

const CreditInvoicesPanel: FC<CreditInvoicesPanelProps> = ({ creditInvoices }: CreditInvoicesPanelProps) => {
    const { t: translate } = useTranslation(['invoices']);
    const navigate = useNavigate();

    const goToCreditInvoice = (creditInvoiceId: string) => {
        navigate(`/invoices/${creditInvoiceId}/summary`);
    };

    return (
        <Fragment>
            <Box mb={1}>
                <Box>
                    <Typography variant="subtitle2">{translate('THIS_INVOICE_HAS_BEEN_CREDITED_BY')}</Typography>
                </Box>
            </Box>

            <Box mb={2}>
                <Divider />
            </Box>
            {creditInvoices.map((creditInvoice, index) => {
                return (
                    <Box key={index} display="flex">
                        <Box flex="1 0 75%">
                            <Link onClick={() => goToCreditInvoice(creditInvoice._id)} href="#">
                                {translate('CREDIT_INVOICE')}: {creditInvoice.invoiceNumber}
                            </Link>
                        </Box>
                        <Box alignSelf="flex-end">
                            <Typography variant="subtitle2" color="error">
                                {formatCurrency(creditInvoice.total?.totalIncVat || 0, creditInvoice.total?.currency)}
                            </Typography>
                        </Box>
                    </Box>
                );
            })}
        </Fragment>
    );
};

export default CreditInvoicesPanel;
